import { Autocomplete, Checkbox, FormControlLabel, TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalQuestion(props) {
    const [questionTypesData, setQuestionTypeData] = useState([]);
    const [qResponseTypesData, setQResponseTypeData] = useState([]);
    const [tables, setTables] = useState([]);

    const [questionText, setQuestionText] = useState("");
    const [questionDesc, setQuestionDesc] = useState("");
    const [questionPlaceholder, setQuestionPlaceholder] = useState("");
    const [questionType, setQuestionType] = useState("");
    const [qResponseType, setQResponseType] = useState("");
    const [questionTableName, setQTableName] = useState("");
    const [questionMultOptions, setQMultOptions] = useState([]);
    const [isRequired, setIsRequired] = useState(false);
    const [isRepeatable, setIsRepeatable] = useState(false);
    const [hasLimit, setHasLimit] = useState(false);
    const [minRepeat, setMinRepeat] = useState("");
    const [maxRepeat, setMaxRepeat] = useState("");

    const {
        questionModalCreateString,
        questionMCQuestionString,
        questionMCQTypeString,
        questionMCRTypeString,
        questionMCDescString,
        questionMCTableString,
        questionMCOptionsString,
        questionMCPlaceholderString,
        saveString,
        isRequiredString,
        isRepeatableString,
        hasLimitString,
        questionMCMinRepeatString,
        questionMCMaxRepeatString,
        questionTypeTextfield,
        questionTypeNumeric,
        questionTypeDropbox,
        questionTypePhoto,
        questionTypeSection,
        questionTypeMessage,
        questionTypeDateTime,
        answerTypeText,
        answerTypeLongText,
        answerTypeNumber,
        answerTypeDecimal,
        answerTypePercentage,
        answerTypeCurrency,
        answerTypeTable,
        answerTypeMultipleOption,
        answerTypeFile,
        answerTypeCamera,
        answerTypeGallery,
        answerTypeNA,
        answerTypeDate,
        answerTypeTime
    } = useTranslationHook();

    function createQuestion(event) {
        event.preventDefault();

        if (isRequired === true) {
            var qRequired = 1;
        }else{
            qRequired = 0;
        }

        if (isRepeatable === true) {
            var qRepeatable = 1;
        }else{
            qRepeatable = 0;
        }

        customAxios.post(`${GlobalVariables.getURL()}createQuestion/${props.selectedSection}`, {
            name: questionText,
            description: questionDesc,
            question_type_id: questionType,
            answer_type_id: qResponseType,
            table_name: questionTableName,
            placeholder: questionPlaceholder,
            is_required: qRequired,
            multiple_options: questionMultOptions,
            questionnaire_id: props.selectedQuestionnaire,
            is_repeatable: qRepeatable,
            min_repeat: minRepeat,
            max_repeat: maxRepeat,
            num_columns: 1
        }, {
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        })
            .then((response) => {
                hide();
            }, (error) => {
                console.log(error);
                getToast({ status: 'error', title: 'Error al crear pregunta. Vuelve a intentarlo.' });
            });
    }
    
    /**
     * @summary Translate types to current language.
     *
     * @desc Translated all the objects inside the typesArray to the current locale by mapping all the existing
     * items inside the array and comparing them with the translation map.
     * 
     * @since 1.0.0
     * 
     * @function translateTypes
     * 
     * @param {Array}   typesArray      Array with all the types to translate.
     * @param {Object}  translationMap  Object containing the map for translating question and answers types.
     * 
     * @returns {void}
     */
    function translateTypes(typesArray, translationMap) {
        return typesArray.map((type) => {
            const translatedType = translationMap[type.name] || type.name;

            return { ...type, name: translatedType};
        });
    }

    const translationMap = {
        // Translation map for question types
        'Campo de texto': questionTypeTextfield,
        'Numérica': questionTypeNumeric,
        'Dropbox': questionTypeDropbox,
        'Fotografía': questionTypePhoto,
        'Objeto': questionTypeSection,
        'Mensaje': questionTypeMessage,
        'Fecha y hora': questionTypeDateTime,

        // Translation map for answer types
        'Texto': answerTypeText,
        'Número entero': answerTypeNumber,
        'Número decimal': answerTypeDecimal,
        'Porcentaje': answerTypePercentage,
        'Divisa': answerTypeCurrency,
        'Texto largo': answerTypeLongText,
        'Tabla de base de datos': answerTypeTable,
        'No aplica': answerTypeNA,
        'Opción múltiple': answerTypeMultipleOption,
        'Archivo': answerTypeFile,
        'Camara': answerTypeCamera,
        'Galeria': answerTypeGallery,
        'Fecha': answerTypeDate,
        'Hora': answerTypeTime,
    }

    function getQuestionTypes() {
        customAxios.get(`${GlobalVariables.getURL()}sendQuestionTypes`,{
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        })
            .then((response) => {
                const translatedTypesArray = translateTypes(response.data, translationMap);
                setQuestionTypeData(translatedTypesArray);
            })

            .catch(error => console.log(error));
    }

    function getQAnswerTypes(question_type_id) {
        if (question_type_id) { // Check if question_type_id is not null or undefined
            customAxios.get(`${GlobalVariables.getURL()}sendAnswerTypes?question_type_id=${question_type_id}`, {
                headers: {
                    'Authorization': 'bearer ' + localStorage.getItem('token')
                }
            })
                .then((response) => {
                    const translatedTypesArray = translateTypes(response.data, translationMap);
                    setQResponseTypeData(translatedTypesArray);
                })
                .catch(error => console.log(error));
        } else { // If question_type_id is null or undefined, clear the QResponseTypeData
            setQResponseTypeData([]);
        }
    }

    // This function will reset the state and get called when the modal is closed
    function resetState() {
        setQuestionType(null);
        setQResponseTypeData([]);
    }

    function getTables() {
        customAxios.get(`${GlobalVariables.getURL()}sendTableNames`, {
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        })
            .then((response) => {
                setTables(response.data);
            })

            .catch(error => console.log(error));
    }

    const handleCheckboxChange = (event) => {
        setIsRequired(event.target.checked);
    };

    const handleRepeatCheckboxChange = (event) => {
        setIsRepeatable(event.target.checked);
        if (hasLimit) setHasLimit(false);
    };

    const handleLimitCheckboxChange = (event) => {
        setHasLimit(event.target.checked);
    }

    useEffect(() => {
        getQuestionTypes();
        getTables();
    }, []);


    function hide() {
        props.onHide();
        getToast({ status: 'success', title: 'Pregunta creada exitosamente en el cuestionario.' });
        props.getQuestionsData(props.selectedSection);
        props.getDirectoryData();
        resetFormFields();
    }

    async function resetFormFields() {
        await props.onHide();
        setQuestionText("");
        setQuestionDesc();
        setQuestionPlaceholder("");
        setQuestionType("");
        setQResponseType("");
        setQTableName("");
        setQMultOptions([]);
        setIsRequired(false);
        setIsRepeatable(false);
        setMinRepeat("");
        setMaxRepeat("");
    }

    return (
        <Modal
            {...props}
            onClose={resetFormFields}
            onHide={resetFormFields}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {questionModalCreateString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id='add-question-form' onSubmit={createQuestion}>
                    <div className="row" style={{ display: "flex", alignItems: "center" }}>
                        <div className="col-md-9">
                            <TextField
                                sx={{ width: "100%" }}
                                label={questionMCQuestionString}
                                type="text"
                                value={questionText} onChange={(e) => setQuestionText(e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-md-3">
                            <FormControlLabel control={<Checkbox checked={isRequired} onChange={handleCheckboxChange}/>} label={isRequiredString} />
                            <FormControlLabel control={<Checkbox checked={isRepeatable} onChange={handleRepeatCheckboxChange}/>} label={isRepeatableString} />
                            {isRepeatable && <FormControlLabel control={<Checkbox checked={hasLimit} onChange={handleLimitCheckboxChange}/>} label={hasLimitString} />}
                        </div>
                    </div>

                    <br />

                    {hasLimit && (
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <TextField
                                        sx={{ width: "100%" }}
                                        label={questionMCMinRepeatString}
                                        value={minRepeat} onChange={(e) => setMinRepeat(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <TextField
                                        sx={{ width: "100%" }}
                                        label={questionMCMaxRepeatString}
                                        value={maxRepeat} onChange={(e) => setMaxRepeat(e.target.value)}
                                    />
                                </div>
                            </div>

                            <br />
                        </>
                    )}

                    <div className="row">
                        <div className="col-md-12">
                            <TextField
                                multiline
                                sx={{ width: "100%" }}
                                label={questionMCDescString}
                                rows={4}
                                type="text"
                                value={questionDesc} onChange={(e) => setQuestionDesc(e.target.value)}
                            />
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-md-12">
                            <TextField
                                multiline
                                sx={{ width: "100%" }}
                                label={questionMCPlaceholderString}
                                rows={2}
                                type="text"
                                value={questionPlaceholder} onChange={(e) => setQuestionPlaceholder(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        <div className="col-md-6">
                            <Autocomplete
                                sx={{ width: "100%" }}
                                disablePortal
                                includeInputInList={false}
                                options={questionTypesData}
                                getOptionLabel={(questionTypesData) => questionTypesData.name}
                                getOptionSelected={(questionTypesData, value) => questionTypesData.id === value.id}
                                renderInput={(params) => <TextField {...params} label={questionMCQTypeString} required />}
                                onChange={(event, newValue) => {
                                    if (newValue) { // Check if newValue is not null or undefined
                                        setQuestionType(newValue.id);
                                        getQAnswerTypes(newValue.id);
                                    } else { // If newValue is null or undefined, clear the QuestionType and QResponseTypeData
                                        setQuestionType(null);
                                        getQAnswerTypes(null);
                                    }
                                }}
                            />


                        </div>
                        <div className="col-md-6">
                            <Autocomplete
                                sx={{ width: "100%" }}
                                disablePortal
                                includeInputInList={false}
                                options={qResponseTypesData}
                                getOptionLabel={(qResponseTypesData) => qResponseTypesData.name}
                                getOptionSelected={(qResponseTypesData, value) => qResponseTypesData.id === value.id}
                                renderInput={(params) => <TextField {...params} label={questionMCRTypeString} required />}
                                onChange={(event, newValue) => {
                                    setQResponseType(newValue.id);
                                }}
                            />
                        </div>
                    </div>

                    {qResponseType === 9 && (
                        <>
                            <br />

                            <div className="row">
                                <div className="col-md-12">
                                    <Autocomplete
                                        sx={{ width: "100%" }}
                                        disablePortal
                                        includeInputInList={false}
                                        options={tables}
                                        getOptionLabel={(tables) => tables}
                                        getOptionSelected={(tables, value) => tables === value}
                                        renderInput={(params) => <TextField {...params} label={questionMCTableString} required />}
                                        onChange={(event, newValue) => {
                                            setQTableName(newValue);
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {qResponseType === 11 && (
                        <>
                        <br />

                        <div className="row">
                            <div className="col-md-12">
                                <Autocomplete
                                    multiple
                                    sx={{ width: "100%" }}
                                    disablePortal
                                    freeSolo
                                    options={[]}
                                    renderInput={(params) => (
                                        <TextField 
                                            {...params} 
                                            label={questionMCOptionsString}
                                            required={questionMultOptions.length === 0} 
                                        />
                                    )}
                                    onChange={(event, newValue) => {
                                        setQMultOptions(newValue);
                                    }}
                                />
                            </div>
                        </div>
                        </>
                    )}
                </form>
            </Modal.Body>
            <Modal.Footer>
                <button form='add-question-form' type='submit' className='save-modal-button'>{saveString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalQuestion;